module.exports = __webpack_public_path__ + "static/media/avatar2.206b6020.png";